import i18next from "i18next";

export const updateData = (_this, contextName, data, callback) => {
  data = JSON.parse(JSON.stringify(data));

  const lazyLoading = setTimeout(() => {
    _this.$store.commit("setSnackbarLoading", {
      message: i18next.t("Atualizando_aguarde"),
      status: true,
    });
  }, 800);

  _this.$store.dispatch(contextName + "/updateData", {
    register: data,
    token: _this.$store.state.auth.user.token,
    callbackError: (err) => {
      clearTimeout(lazyLoading);
      _this.$store.commit("setSnackbarLoading", {
        status: false,
      });
      _this.$store.commit("setSnackbarError", {
        message:
          err && [401, 403].includes(err.status)
            ? i18next.t("sessao_expirada_redirecionando")
            : i18next.t("erro_inesperado_tente_novamente"),
        status: true,
      });

      setTimeout(() => {
        _this.$store.commit("setSnackbarError", {
          status: false,
        });
        if (err.response && err.response.status === 403) {
          _this.$store.dispatch("auth/logout");
          _this.$router.push("/login");
        }
      }, 4000);
    },
    callbackSuccess: (data) => {
      clearTimeout(lazyLoading);
      _this.$store.commit("setSnackbarLoading", {
        status: false,
      });
      _this.$store.commit("setSnackbarSuccess", {
        message: i18next.t("Atualizado_sucesso"),
        status: true,
      });
      callback && callback(data);
    },
  });
};

export const uploadFile = (_this, contextName, file, key, updateFunction) => {
  const lazyLoading = setTimeout(() => {
    _this.$store.commit("setSnackbarLoading", {
      message: i18next.t("Atualizando_aguarde"),
      status: true,
    });
  }, 500);

  _this.$store.dispatch(contextName + "/uploadFile", {
    file,
    key,
    token: _this.$store.state.auth.user.token,
    callbackError: (err) => {
      clearTimeout(lazyLoading);
      _this.$store.commit("setSnackbarLoading", {
        status: false,
      });
      _this.$store.commit("setSnackbarError", {
        message:
          err && [401, 403].includes(err.status)
            ? i18next.t("sessao_expirada_redirecionando")
            : i18next.t("erro_inesperado_tente_novamente"),
        status: true,
      });

      setTimeout(() => {
        _this.$store.commit("setSnackbarError", {
          status: false,
        });
        if (err.response && err.response.status === 403) {
          _this.$store.dispatch("auth/logout");
          _this.$router.push("/login");
        }
      }, 4000);
    },
    callback: ({ result }) => {
      updateFunction({ [key]: result[key] });
    },
  });
};
